import {HttpClient} from '@angular/common/http'
import {computed, inject, Service, signal} from '@angular/core'
import {toObservable} from '@angular/core/rxjs-interop'
import {ICollectResult, ISamtyckeUser} from '@samtycke/bankid-gw'
import {of} from 'rxjs'
import {environment} from '../../environments/environment'
import {LOCAL_STORAGE} from '../0-general/providers'
import {ACCESS_TOKEN_KEY} from '../0-general/shared'

@Service()
export class ConfigService {

  /**
   * Public but please use the setter (login / logout)
   */
  public accessToken = signal<ICollectResult | null>(null)
  public accessToken$ = toObservable(this.accessToken)

  /**
   * The token to use when calling /sign/complete
   */
  public signToken = signal('')

  public user = signal<ISamtyckeUser | null>(null)

  /**
   * We should extend this with check for expiry. Let us to that
   * when we implement refresh tokens.
   */
  public accessTokenValid = computed(() => {
    return this.accessToken() !== null
  })

  private readonly storage = inject(LOCAL_STORAGE)
  private readonly http = inject(HttpClient)

  public bootstrap() {
    try {
      this.login(JSON.parse(this.storage.getItem(ACCESS_TOKEN_KEY)!))
    } catch {
      this.logout()
    }
    return of(true)
  }

  public logout(): void {
    this.storage.removeItem(ACCESS_TOKEN_KEY)
    this.accessToken.set(null)
  }

  public self() {
    const url = `${environment.bankIdGatewayUrl}/self`
    return this.http.get<Required<ISamtyckeUser>>(url)
  }

  public login(token: ICollectResult | null): void {
    if (!token) {
      return
    }
    this.storage.setItem(ACCESS_TOKEN_KEY, JSON.stringify(token))
    this.accessToken.set(token)
    this.self()
      .subscribe(user => this.user.set(user))
  }
}
